import { callDeepLink, compareWithAppVersion } from '@croquiscom/web2app';

import { checkZPayFunctionExists } from '@common/log-manager';

export const openFullScreenSimpleBrowser = (pathname: string, disabledHostPrefix?: boolean) => {
  const href = disabledHostPrefix ? pathname : window.location.origin + pathname;
  if (checkZPayFunctionExists(window)) {
    callDeepLink('/full_screen_simple_browser')({
      url: encodeURIComponent(href),
    });
  } else {
    window.open(href, '_blank');
  }
};

export const checkAppVersionAndRedirectToStoreHome = (shop_id: string, shop_main_domain: string) => {
  if (compareWithAppVersion('6.53.0')) {
    callDeepLink(`/store_home`)({ shop_id, shop_main_domain });
  }
};

export const gotoShopHome = (shop_main_domain: string, shop_url: string, origin = '') => {
  if (checkZPayFunctionExists(window)) {
    if (!origin) {
      callDeepLink(`/shops/${shop_main_domain}`)();
    } else {
      callDeepLink(`/shops/${shop_main_domain}`)({ zz_origin: origin });
    }
  } else {
    window.open(shop_url, '_blank');
  }
};

export const gotoShopCategory = (params: {
  shop_id: string;
  detailed_category?: string;
  display_category_id?: string;
  title: string;
  store_home_deep_link: string | null;
  zz_origin?: string;
}) => {
  if (!checkZPayFunctionExists(window)) {
    return;
  }
  if (params.store_home_deep_link) {
    const deepLinkUrls = params.store_home_deep_link.replace('zigzag://', '').split('?');
    const linkUrl = deepLinkUrls[0];
    const linkParams = deepLinkUrls[1].split('&');
    linkParams.push('zz_origin=zonly');

    callDeepLink(`${linkUrl}?${linkParams.join('&')}`)();
    return;
  }
  callDeepLink('/shop_category_goods_list')(params);
};
